import { Box } from "@hightouch/htui";
import { useEffect, useRef, type ReactNode } from "react";

/** Fetches a list's next page once scrolled into view. */
export function LoadMoreSentinel({
  onVisible,
  children,
}: {
  onVisible: () => void;
  /** The placeholder shown while the page loads, sized like a row. */
  children: ReactNode;
}) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        onVisible();
      }
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, [onVisible]);

  return (
    <Box ref={ref} flexShrink={0}>
      {children}
    </Box>
  );
}
